import history from "../../History/History";
import AuthService from "../../Services/AuthService/AuthService";
import { notifUtils } from "../NotifUtils/NotifUtils";
const logoutPath = localStorage.getItem("logout");

const clearLocalStorage = async () => {
  try {
    const response = await AuthService.logout();
    if (response) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("instanceToken");
      localStorage.removeItem("notif");
      localStorage.removeItem("authdata");
      localStorage.removeItem("logout");
      localStorage.removeItem("roomId");
      localStorage.removeItem("lastVisit");
      notifUtils("Logout Successfully", "success");
      window.location.href = "/login";
    }
  } catch (e) {
    console.log(e);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("instanceToken");
    localStorage.removeItem("notif");
    localStorage.removeItem("authdata");
    localStorage.removeItem("roomId");
    localStorage.removeItem("lastVisit");
    notifUtils("Your Session has been Expired", "error");
    window.location.href = "/login";
  }
};

const handleError = (error) => {
  const message = error?.response?.data ? error?.response?.data?.message : "Error request from API"
  const status = error.response ? error.response.status : "";
  if (status) {
    if (status === 401 || status === 402 || status === 403) {
      clearLocalStorage();
    } else {
      notifUtils( status + " - " + message, "warning");
    }
  }
};

const extractImageFileExtensionFromBase64 = (base64Data) => {
  return base64Data.substring(
    "data:image/".length,
    base64Data.indexOf(";base64")
  );
};

const image64toCanvasRef = (
  canvasRef,
  image64,
  pixelCrop,
  fileName,
  extImage
) => {
  const canvas = canvasRef; // document.createElement('canvas');
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext("2d");
  const image = new Image();
  image.src = image64;
  image.onload = function () {
    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );
  };
  return new Promise((resolve) => {
    resolve(true);
  });
};

const base64StringtoFile = (base64String, filename) => {
  var arr = base64String.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

const formatRupiah = (prefix, angka) => {
  var number_string = angka.replace(/[^,\d]/g, "").toString(),
    split = number_string.split(","),
    sisa = split[0].length % 3,
    rupiah = split[0].substr(0, sisa),
    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

  // tambahkan titik jika yang di input sudah menjadi angka ribuan
  if (ribuan) {
    let separator = sisa ? "." : "";
    rupiah += separator + ribuan.join(".");
  }

  rupiah = split[1] !== undefined ? rupiah + "," + split[1] : rupiah;
  return prefix === undefined ? rupiah : rupiah ? "IDR " + rupiah : "";
};

const chunkArray = (array, size) => {
  const chunked_arr = [];
  for (let i = 0; i < array.length; i++) {
    const last = chunked_arr[chunked_arr.length - 1];
      if (!last || last.length === size) {
        chunked_arr.push([array[i]]);
      } else {
        last.push(array[i]);
      }
  }
  return chunked_arr;
}

export {
  clearLocalStorage,
  handleError,
  extractImageFileExtensionFromBase64,
  image64toCanvasRef,
  base64StringtoFile,
  formatRupiah,
  chunkArray,
};
